export const translationsEn = {
  _hide: 'Hide',
  _publish: 'Publish',
  _save: 'Save',
  _open: 'Open',
  _close: 'Close',
  _delete: 'Delete',
  _cancel: 'Cancel',
  _from: 'From',
  _to: 'To',
  _between_to: 'to',
  _search: 'Search',
  _successful: 'Successful',
  _clearSuccessful: 'Successful',
  _ok: 'OK',
  _edit: 'Edit',
  _confirm: 'Confirm',
  _saveCompleted: 'Save completed',
  _saveFailed: 'Save failed',
  _logout: 'Log out',
  _select: 'Please select',
  _upload_image: 'Upload image',
  _upload_image_recommend_spec: 'Recommended image size is {image_size} and file size not exceed {file_size}',
  _resize_image_recommend_spec: 'Zooming in on an image may affect image quality.',
  _status: 'Status',
  _clear: 'Clear',
  _manual: 'Manual',
  _click_here: 'Click',
  _baht: 'Baht',
  _preview: 'Preview',
  _add: 'Add',
  _import: 'Import',
  _sort: 'Sort Product',
  _sort_by: 'Sort by',
  _move_to_top: 'Move to top',
  _move_to_bottom: 'Move to bottom',
  _custom: 'Custom',
  _pin: 'Pin',
  _unpin: 'Unpin',
  _learn_more: 'Learn More',
  _firstname: 'Firstname',
  _lastname: 'Lastname',
  _add_field: 'Add field',
  _free: 'Free',
  _product_name: 'Product Name',
  _data: 'Data',
  _detail: 'Detail',
  _note: 'Note',
  _last_edited: 'Last edited',
  _by: 'By',
  product_buttons_label: 'Products list',
  Unauthorized: '401: Unauthorized',
  menu_product: 'Products',
  menu_order: 'Manage',
  menu_settings: 'Settings',
  menu_max_products: 'Max Products',
  menu_max_products_unlimit: 'Unlimit',
  category: 'Category',
  category_add: 'New Category',
  category_parent_category: 'Parent Category',
  category_detail: 'Detail',
  category_name: 'Category Name',
  category_validate_please_insert_a_category_name: 'Please insert a category name',
  category_staticURL: 'Static URL',
  order_from: 'Order from',
  order_ID: 'Order ID',
  order_date: 'Order Date',
  order_shipping_address: 'Shipping Address',
  order_name: 'Name',
  order_address: 'Address',
  order_province: 'Province',
  order_country: 'Country',
  order_postcode: 'Postcode',
  order_tel: 'Tel',
  order_email: 'Email',
  order_billing_address: 'Billing Address',
  order_product_details: 'Product Details',
  order_product: 'Product',
  order_price: 'Price',
  order_qty: 'Qty',
  order_total: 'Total',
  order_type: 'Type',
  order_type_cart: 'Order',
  order_type_contact: 'Contact',
  order_subtotal: 'Subtotal',
  order_shipping: 'Shipping',
  order_payment_method: 'Payment Method',
  order_payment_method_Transfer: 'Transfer',
  order_payment_method_omise: 'Credit Card',
  order_payment_method_kpayment_card: 'Credit Card',
  order_payment_method_kpayment_qr: 'QR Code',
  order_remask: 'Remask',
  order_create_date: 'Create Date',
  order_SKU: 'SKU',
  order_search_placeholder_select_date: 'Click to Select ...',
  order_contact_form: 'Contact Form',
  products_management: 'Products Management',
  products_setup: 'Products setup',
  products_sorting: 'Products sorting',
  products_management_sorting_options_select: 'Select',
  product_advance_search: 'More options ',
  product_advance_search_between: 'Between',
  product_advance_search_please_select_one: 'Please select one',
  product_advance_search_stock: 'Stock',
  product_advance_search_price: 'Price',
  validatefail_price: 'Please enter only numbers and do not more than 2-digit decimal.',
  validatefail_stock: 'Please enter only numbers.',
  validatefail_normal_price: 'Incorrect product normal price',
  validatefail_member_price: 'Incorrect product member price',
  validatefail_special_price: 'Incorrect product special price',
  validatefail_staticurl_dup: 'Duplicate static URL',
  validatefail_staticurl_format: 'Invalid Format. Please fill text or text with number or - and do not have space in Static URL.',
  validatefail_productRelateSearch: 'Please insert a product name with more than 1 character',
  validatefail_weight: 'Incorrect product weight',
  validatefail_normal_price_lower_than_special: 'Normal Price must greater than Special Price',
  validatefail_normal_price_lower_than_member: 'Normal Price must greater than Member Price',
  validatefail_special_price_greater_than_normal: 'Special Price must not greater than Normal Price',
  validatefail_member_price_greater_than_normal: 'Member Price must not greater than Normal Price',
  validatefail_special_and_member_price_greater_than_normal: 'Normal Price must greater than Special Price and Member Price',
  modal_confirm_del: 'Confirm Delete Product?',
  modal_confirm_del_contact_form: 'Confirm Delete contact form?',
  modal_confirm_del_contact_form_field: 'Confirm Delete contact form field?',
  modal_confirm_del_field: 'Confirm Delete order custom form field?',
  modal_confirm_del_payment_field: 'Confirm Delete payment field?',
  modal_confirm_del_velaeasy_sections: 'This product has content sections on a R-Web system. If you delete this product, The content section will also be deleted <br><br> Confirm Delete Product ?',
  modal_confirm_del_shipping_type: 'Confirm Delete shipping type?',
  modal_delete_category_dialog_velaeasy_sections: 'This category has content sections on a R-Web system. If you delete this category, The content section will also be deleted <br><br> <br> Are you sure you want to <b>delete</b> <i>{name}</i>? <br>This action cannot be undone.',
  modal_confirm_del_cate: 'Confirm Delete Category?',
  modal_confirm: 'Confirm',
  modal_cancel: 'Cancel',
  modal_success: 'Success',
  modal_success_del: 'Delete Product Success.',
  modal_success_del_contact_form: 'Delete contact form success',
  modal_success_del_field: 'Delete order custom form field success',
  modal_success_del_payment_field: 'Delete payment field success',
  modal_success_del_shipping_type: 'Delete shipping type success',
  modal_error_occured: 'Error occured! Please try again later.',
  modal_fail_apply_all: 'Do not use empty normal price to apply all in this page',
  modal_fail: 'Please recheck a product data.',
  modal_fail_processing_static_url_input: 'Processing a Static URL data, Please try again.',
  modal_fail_processing_sku_input: 'Processing SKU data, Please try again.',
  modal_cancel_update: 'You are leaving without save, Do you want to save changes?',
  modal_dont_save: 'Don\'t save',
  modal_apply_to_all: 'Yes, Apply to all',
  modal_delete: 'Do you want to delete this item?',
  modal_image_limit: 'You can only upload an image up to',
  modal_image_items: 'items.',
  modal_image_crop_limit: 'You can upload only one image at once.',
  modal_disabled_product_variants: 'Please save your product before access this setting.',
  modal_confirm_generate: 'Generate new variants?',
  modal_confirm_generate_alert: 'Variants will be deleted and generate new',
  modal_generating: 'Please wait and do not close application.',
  modal_processing: 'Processing',
  modal_generate_complete: 'Generate Complete',
  modal_delete_product_var: 'Do you want to delete product variant ?',
  modal_delete_category_title: 'Delete category',
  modal_delete_category_dialog: 'Are you sure you want to <b>delete</b> <i>{name}</i>? <br>This action cannot be undone.',
  modal_delete_category_cancel: 'Cancel',
  modal_delete_category_confirm: 'Delete',
  modal_delete_category_fail: 'Unable to delete this category because its sub-category or product still remains.',
  modal_delete_relate: 'Do you want to delete this relate product?',
  modal_title_delete: 'Delete',
  modal_fail_del: 'Cannot be delete ,because this category have some product or sub-category',
  modal_title_logout: 'Logout',
  modal_title_clear: 'Clear Data',
  modal_clear: 'Do you want to clear these data?',
  modal_logout: 'Do you want to logout ?',
  modal_title_warning: 'Warning',
  modal_currency_not_support_some_payments: 'Do you want to use this currency and disable these payment method that not supported?',
  modal_quota_rpshop_products: 'Your package can not add more products.<br>Do you want to upgrade your package?',
  modal_quota_rpshop_product_variants: 'Your package can not add product variants.<br>Do you want to upgrade your package?',
  modal_quota_contact_form: 'Your package can not add contact form.<br>Do you want to upgrade your package?',
  modal_confirm_to_toggle_all_country: 'Your selected countries will be removed, Do you want to continue?',
  modal_confirm_delete_shipping_region: 'Confirm to delete this shipping region?',
  modal_delete_shipping_region_success: 'Delete shipping region success',
  product_list_total: 'Total {total} items',
  product_list_name: 'Name',
  product_list_add_product: 'New Product',
  product_list_normal_price: 'Normal Price',
  product_list_member_price: 'Member Price',
  product_list_special_price: 'Special Price',
  product_list_image: 'Image',
  product_list_stock: 'Stock',
  product_list_status: 'Status',
  product_list_status_show: 'Show',
  product_list_status_hide: 'Hide',
  product_list_status_show_member: 'Show only members',
  product_list_action: 'Action',
  product_list_search_product_not_found: 'Product not found',
  product_list_search_please_fill_keyword: 'Please fill keywords more than 1 character or price or stock',
  product_list_search_please_fill_correct_price: 'Please check price input',
  product_list_category_deleted_complete: 'Category elete completed',
  product_list_category_cannot_deleted: 'Can not delete category',
  product_info_add_product: 'Add Product',
  product_info_edit_product: 'Edit Product',
  product_info_basic_setting: 'Basic Settings',
  product_info_product_variants: 'Variants',
  product_basic_setting_image: 'Image',
  product_basic_setting_add_product_relate: 'Add Product Related',
  product_basic_setting_relate_add_product: 'Add Product',
  product_basic_setting_name: 'Product Name',
  product_basic_setting_SKU: 'SKU',
  product_basic_setting_relate_search_product_name_n_sku: 'Product Name, SKU',
  product_basic_setting_select_a_contact_form: 'Select a contact form',
  product_basic_setting_validate_product_name_required: 'Please insert a product name',
  product_basic_setting_validate_contact_form_required: 'Please select a contact form.',
  product_basic_setting_validate_product_limit: 'Product name over 200 characters',
  product_basic_setting_detail: 'Detail',
  product_basic_setting_normal_price: 'Price',
  product_basic_setting_original_price: 'Normal Price',
  product_basic_setting_special_price: 'Special Price',
  product_basic_setting_member_price: 'Member Price',
  product_basic_setting_discount_percentage: 'Discount {percent} % from normal price',
  product_basic_setting_staticURL: 'Static URL',
  product_basic_setting_stock: 'Stock',
  product_basic_setting_status: 'Status',
  product_basic_setting_status_show: 'Show',
  product_basic_setting_status_hide: 'Hide',
  product_basic_setting_status_show_only_members: 'Show only members',
  product_basic_setting_product_group: 'Category',
  product_basic_setting_relate_search_no_result: 'No Result',
  product_basic_setting_related_product: 'Related Product',
  product_basic_setting_related_products: 'Related products',
  product_basic_setting_validate_sku_required: 'Please insert SKU',
  product_basic_setting_validate_sku_duplicate: 'Duplicate SKU',
  product_basic_setting_validate_sku_limit: 'SKU over 255 characters',
  product_basic_setting_validate_sku_specialchar: 'No special characters allowed',
  product_basic_setting_order_style: 'Order Type',
  product_basic_setting_order_style_buy_now_button: 'Buy now button',
  product_basic_setting_order_style_contact_form: 'Contact Form',
  product_basic_setting_order_style_hide_quantity_selection: 'No display quantity selector',
  product_basic_setting_order_style_hide_price: 'Hide price',
  product_basic_setting_weight: 'Weight (g)',
  product_basic_setting_label: 'Label',
  product_basic_setting_product_label_new: 'New',
  product_basic_setting_product_label_best_seller: 'Best Seller',
  product_basic_setting_product_label_recommended: 'Recommended',
  product_variant_attribute: 'Attribute',
  product_variant_attribute_values: 'Attribute Values',
  product_variant_generate: 'Generate',
  product_variant_selectall: 'Select All',
  product_variant_name: 'Name',
  product_variant_image: 'Image',
  product_variant_normal_price: 'Normal Price',
  product_variant_special_price: 'Special price',
  product_variant_member_price: 'Member price',
  product_variant_stock: 'Stock',
  product_variant_status: 'Status',
  product_variant_action: 'Action',
  product_variant_weight: 'Weight',
  product_variant_weight_g: 'g',
  product_variant_weight_tips: 'product\'s weight will be used when this field is blank',
  product_variant_validate_weight_incorrect: 'Please enter only numbers',
  product_variant_validate_weight_limit_exceed: 'Weight limit exceed {limit}',
  product_variant_validate_stock_incorrect: 'Please enter only numbers',
  product_variant_validate_sku_required: 'Please insert SKU',
  product_variant_validate_sku_duplicate: 'Duplicate SKU',
  product_variant_validate_sku_limit: 'SKU over 255 characters',
  product_variant_status_show: 'Show',
  product_variant_status_hide: 'Hide',
  product_variant_status_out: 'Out of Stock',
  product_variant_delete: 'Delete',
  product_variant_selected: 'Selected:',
  product_variant_deleteall: 'Delete All',
  product_variant_placeholder_attr: 'e.g. Size',
  product_variant_product_attribute_add_a_tag: 'e.g. S, M, L',
  product_variant_placeholder_color_attr: 'e.g. Color',
  product_variant_product_attribute_color_add_a_tag: 'e.g. Red, Blue, Green',
  product_variant_placeholder_type_attr: 'e.g. Type',
  product_variant_product_attribute_type_add_a_tag: 'e.g. T-Shirt, Polo, Shirt',
  product_variant_SKU: 'SKU',
  product_variant_update_success: 'Update Successful',
  product_variant_popper_apply_to_all: 'Apply to all on this page',
  product_variant_apply_to_all_question: 'Do you want to apply to all {field} ?',
  product_variant_attribute_generate_error: 'Please full input before generate',
  product_variant_attribute_generate_title: 'Confirm Generate',
  product_variant_attribute_generate_message: 'Delete all old products and create new products',
  product_variant_attribute_generate_add_success: 'Save Successful',
  product_variant_attribute_generate_add_error: 'Generate failed',
  product_variant_attribute_generate_add_error_or_limit_over_1000: 'Could not generate product variants more than 1,000 items',
  product_variant_attribute_not_allow_brackets: 'Not allow "[" and "]"',
  currency_settings: 'Currency',
  setting: 'Setting',
  setting_currency: 'Currency Display',
  setting_currency_iso: 'ISO 4217 Currency Code',
  setting_currency_iso_validate_required: 'Please select currency',
  setting_currency_custom: 'Custom',
  setting_currency_custom_validate_required: 'Please full input currency',
  setting_currency_custom_validate_limit: 'Currency should be maximum 10 character',
  setting_currency_preview: 'Preview',
  setting_currency_prefix: 'Prefix',
  setting_currency_suffix: 'Suffix',
  shipping_settings: 'Shipping',
  shipping_settings_delete: 'Delete',
  shipping_settings_add: 'New Region',
  shipping_settings_empty_list: 'No shipping',
  shipping_settings_delete_title: 'Delete shipping',
  shipping_settings_delete_dialog: 'Do you want to <b>delete</b> this shipping ?',
  shipping_settings_edit_title: 'Edit shipping',
  shipping_settings_toast_save_complete: 'Save completed',
  shipping_settings_toast_delete_complete: 'Delete completed',
  shipping_validate_name_failed: 'Please insert shipping name',
  shipping_validate_name_failed_limit: 'Name over 100 characters',
  shipping_validate_price_failed: 'Please insert price in a number format',
  shopping_cart_text_settings: 'Shopping Cart Text',
  shopping_cart_text_settings_cart: 'Shopping cart',
  shopping_cart_text_settings_thankyou: 'Thank you page',
  shopping_cart_text_settings_cancel: 'Restore current data',
  shopping_cart_text_settings_cancel_message: 'An unsaved data will be lost, Do you want to continue?',
  payment_settings: 'Payment',
  payment_settings_validate_omise_public_key: 'Please insert public key',
  payment_settings_validate_omise_secret_key: 'Please insert secret key',
  payment_settings_validate_paypal_client_id: 'Please insert client id',
  payment_settings_validate_paypal_secret: 'Please insert secret',
  payment_settings_validate_transfer_manual_text: 'Please insert manual label',
  payment_settings_validate_custom_text: 'Please insert text',
  payment_settings_validate_kpayment_merchant_id: 'Please insert Merchant ID',
  payment_settings_validate_kpayment_public_key: 'Please insert Public key',
  payment_settings_validate_kpayment_secret_key: 'Please insert Secret key',
  payment_settings_currency: 'Currency',
  payment_settings_currency_not_support: 'Can\'t enable this payment method with selected currency.',
  payment_settings_currency_display: 'Display',
  payment_settings_currency_position: 'Position',
  payment_settings_currency_symbol: 'Symbol',
  payment_settings_currency_prefix: 'Prefix',
  payment_settings_currency_suffix: 'Suffix',
  payment_settings_transfer: 'Bank Transfer',
  payment_settings_transfer_title: 'Bank Transfer',
  payment_settings_transfer_text: 'Display Text',
  payment_settings_transfer_custom: 'Custom',
  payment_settings_transfer_edit: 'Edit Transfer',
  payment_settings_omise_edit: 'Edit Omise',
  payment_settings_paypal_edit: 'Edit PayPal',
  payment_settings_credit_card_edit: 'Edit Credit Card',
  payment_settings_qr_code_edit: 'Edit QR Code',
  payment_settings_kpayment_card_edit: 'Edit K-Payment Gateway',
  payment_settings_kpayment_use_same_config: 'This settings will affect both Credit Card and QR code payment',
  payment_settings_kpayment_use_with_bank: 'Use for register with the bank',
  payment_settings_kpayment_system_info: 'System information',
  payment_settings_kpayment_system_info_email: 'Developers\'s email',
  payment_settings_manual: 'Manual',
  payment_settings_title: 'Set up payments',
  payment_settings_display_title: 'Payment method',
  payment_settings_edit_to_connect: 'To connect',
  payment_settings_as_a_payment_method: 'as a Payment Method, complete account set-up.',
  payment_settings_as_a_payment_method_please_choose: 'as a Payment Method, please choose the message.',
  payment_settings_custom_text: 'Text',
  payment_settings_custom_icon: 'Icon',
  payment_settings_custom_no_icon: 'No icon',
  payment_settings_field_limit_5: 'Payments field has reached maximum of 5',
  export_order_error_title: 'Export Failed',
  export_order_error_content: 'Not found any record or Amount of data is over than 1000 record',
  export_order_confirm_title: 'Confirmed to export order',
  export_order_default: 'Export all orders',
  export_order_date1: 'Start Date',
  export_order_date2: 'End Date',
  export_order_keyword: 'Keyword',
  export_order_create_date: 'Create Date',
  export_order_update_date: 'Order Date',
  export_order_type: 'Type',
  export_order_status: 'Status',
  cc_email_settings: 'Merchant Email',
  cc_email_settings_send_order_email_to_address: 'Send order email to address',
  cc_email_settings_main_email: 'Main Email',
  cc_email_settings_cc_email_1: 'CC Email 1',
  cc_email_settings_cc_email_2: 'CC Email 2',
  cc_email_settings_cc_email_3: 'CC Email 3',
  cc_email_settings_cc_email_4: 'CC Email 4',
  cc_email_settings_validate_required: 'Please insert Main Email',
  cc_email_settings_validate_invalid: 'Invalid email format',
  cc_email_settings_validate_duplicate: 'Duplicated email',
  order_custom_form_settings: 'Order Form',
  order_custom_form_settings_title: 'Set up custom field on your order form',
  order_custom_form_display_title: 'Other Information',
  order_custom_form_required_field: 'Required field',
  order_custom_form_option_field: 'Optional field',
  order_details_custom_form: 'Other Order Information',
  order_details_contact_form: 'Other Contact Form Information',
  order_custom_form_option_field_limit: 'Form field has reached maximum of {limit}',
  order_custom_form_attachment_field_limit: 'Attachments has reached maximum of {limit}',
  order_custom_form_label: 'Label',
  order_custom_form_field_type: 'Field Type',
  order_custom_form_text: 'Text',
  order_custom_form_dropdown: 'Dropdown',
  order_custom_form_require: 'Require',
  order_custom_form_dropdown_options: 'Option',
  order_custom_form_text_placeholder: 'Placeholder',
  order_custom_form_dropdown_append: 'Append',
  order_custom_form_dropdown_replace: 'Replace',
  order_custom_form_no_item: 'No item',
  order_custom_form_plase_upload_csv_file: 'Please upload csv file.',
  order_custom_form_setting_not_found: 'Custom field not found',
  order_custom_form_option_is_null: 'Data is empty.',
  order_custom_form_option_over: 'Data over than {limit} items.',
  order_custom_form_please_insert_label: 'Please insert a label',
  order_custom_form_please_add_options: 'Please add options',
  order_custom_form_option_character_over: 'Some option size over {limit} character.',
  order_custom_form_option_duplicate: 'Duplicate value',
  order_custom_form_datetime_show_time: 'Show time',
  update_products_sorting_toast_complete: 'Save completed',
  update_products_sorting_toast_error: 'Error occured! Try again later',
  category_products_sort_label: 'Sort by',
  sort_options_custom: 'Custom',
  sort_options_newest: 'Newest',
  sort_options_oldest: 'Oldest',
  sort_options_a_to_z: 'A-Z',
  sort_options_z_to_a: 'Z-A',
  sort_options_highest_price: 'Highest price',
  sort_options_lowest_price: 'Lowest price',
  sort_options_confirm_title: 'Sort all products',
  sort_options_confirm_detail: 'This operation will <b>update</b> your current products order. Do you want to continue?',
  no_sub_category: 'No subcategories',
  pinned_products_sortable_hint: 'Pinned products are sortable',
  all_products_sort_label: 'All products sort',
  unpin_product_title: 'Unpin product',
  unpin_product_dialog: 'Do you want to unpin this product?',
  contact_form_settings: 'Contact Form',
  contact_form_settings_title: 'Create contact to purchase form.',
  contact_form_setting_not_found: 'Contact form not found',
  contact_form_name: 'Name',
  contact_form_please_insert_name: 'Please insert name.',
  contact_form_settings_field: 'Setup contact field on your contact form.',
  contact_form_setting_field_not_found: 'Field on your contact form not found',
  contact_form_display_title: 'Form',
  contact_form_settings_detail: 'Contact with customer before purchasing.',
  contact_form_setting_untitle: 'Untitle',
  contact_form_setting_create: 'Create contact form.',
  contact_form_label: 'Label',
  contact_form_please_insert_label: 'Please insert a label.',
  contact_form_please_insert_text: 'Please insert text.',
  contact_form_field_type: 'Field Type',
  contact_form_text: 'Text',
  contact_form_email: 'Email',
  contact_form_tel: 'Telephone',
  contact_form_dropdown: 'Dropdown',
  contact_form_textarea: 'Textarea',
  contact_form_checkbox: 'Checkbox',
  contact_form_radio: 'Radio',
  contact_form_attachment: 'Attachment',
  contact_form_date: 'Date',
  contact_form_datetime: 'Date time',
  contact_form_text_placeholder: 'Placeholder',
  contact_form_dropdown_options: 'Option',
  contact_form_no_item: 'No item',
  contact_form_require: 'Require',
  contact_form_option_over: 'Data over than {limit} items.',
  contact_form_option_duplicate: 'Duplicate value',
  contact_form_please_add_options: 'Please add options',
  contact_form_dropdown_append: 'Append',
  contact_form_dropdown_replace: 'Replace',
  contact_form_option_character_over: 'Some option size over {limit} character.',
  contact_form_option_is_null: 'Data is empty.',
  contact_form_plase_upload_csv_file: 'Please upload csv file.',
  contact_form_setting_button_contact: 'Contact',
  contact_form_setting_button_reserve: 'Reserve',
  contact_form_setting_button_buy_now: 'Buy Now',
  contact_form_settings_button: 'Submit Button',
  contact_form_button_icon: 'Icon',
  contact_form_button_no_icon: 'None',
  contact_form_option_field_limit: 'Form field has reached maximum of {limit}',
  contact_form_attachment_field_limit: 'Attachments has reached maximum of {limit}',
  contact_form_datetime_show_time: 'Show time',
  form_settings: 'Forms',
  form_settings_detail: 'Create form for customer to complete when they purchase or contact.',
  form_settings_shipping: 'Manage your shop ships to.',
  shipping_region_settings_back_to_list_of_regions: 'Back',
  shipping_region_settings_shipping_region: 'Shipping Region',
  shipping_region_settings_add_country_in_this_region: 'Add country in this region.',
  shipping_region_settings_shipping_type: 'Shipping Type',
  shipping_region_settings_add_shipping_type_in_this_region: 'Add shipping type in this region.',
  shipping_region_settings_add_shipping_type: 'Add shipping type',
  shipping_estimate_delivery_time: 'Estimate delivery time',
  shipping_estimate_delivery_time_placeholder: 'Ex. 2 - 10 Business days',
  shipping_name: 'Name',
  shipping_name_placeholder: 'Ex. Free Shipping',
  shipping_description: 'Description',
  shipping_description_placeholder: 'Ex. Free shipping on eligible order',
  shipping_limit_input: 'Limit {limit} characters',
  shipping_type: 'Shipping type',
  shipping_type_free_shipping: 'Free Shipping',
  shipping_description_free_shipping: 'No fee for shipping to your customer',
  shipping_type_flat_rate: 'Flat Rate',
  shipping_description_flat_rate: 'Apply the same fee for an entire order',
  shipping_type_rate_by_quantity: 'By Quantity',
  shipping_description_rate_by_quantity: 'Calculate fee by total products quantity in order',
  shipping_type_rate_by_weight: 'By Weight',
  shipping_description_rate_by_weight: 'Calculate fee by total products weight in order',
  shipping_type_external: 'External Shipping',
  shipping_description_external: 'External fee for shipping when purchased',
  shipping_shop_free: 'Free',
  region_country_selector: 'Select Country',
  all_country: 'All countries except countries that specify in shipping area',
  add_country: '+ Add Country',
  select_country: 'Select Country',
  no_country_result: 'No countries found',
  shipping_region_limit_over: 'Shipping Region has reached maximum of {limit}',
  shipping_settings_free_order: 'Free shipping on order over {rate}',
  shipping_offer_free_shipping: 'Offer free shipping on order over',
  shipping_item_limit_over: 'Shipping type has reached maximum of {limit}',
  shipping_quantity_range: 'Quantity range',
  shipping_weight_range: 'Weight range (g)',
  shipping_rate: 'Fee',
  shipping_add_range: 'Add range',
  shipping_invalid_quantity_data: 'Invalid quantity range and Invalid fee',
  shipping_invalid_weight_data: 'Invalid weight range and Invalid fee',
  shipping_invalid_quantity_range: 'Invalid quantity range',
  shipping_invalid_weight_range: 'Invalid weight range',
  shipping_invalid_rate: 'Invalid fee',
  shipping_invalid_offer_free_shipping_rate: 'Invalid price',
  shipping_and_more_range: 'and up',
  shipping_range_limit: 'Limit {limit} ranges',
  shipping_rate_placeholder: 'Ex. 1000.00',
  shipping_require_name: 'Please insert shipping name',
  shipping_invalid_data: 'Invalid Data',
  shipping_region_list_setting: 'Shipping region list',
  payment_not_support_feature: 'Your current package cannot use this feature',
  accept_credit_card: 'Accept Credit Cards',
  paypal: 'PayPal',
  omise: 'Omise',
  rshop_manual: 'R-Shop User Manual',
  menu_export: 'Export',
  tooltip_menu_export: 'Export Purchase Order',
  tooltip_menu_order: 'Manage Order Status',
  tooltip_menu_product: 'Manage Products',
  tooltip_menu_setting: 'System Settings',
  order_pointspot_discount: 'Discounts from Pointspot',
  shipping_area_defined: 'Set shipping area',
  shipping_area_other: 'Other area',
  shipping_courntry_type: 'Country',
  shipping_thai_province_type: 'Provinces in Thailand',
  other_country: 'Other countries',
  other_thai_province: 'Other provinces in Thailand',
  shipping_other_area_all_province: 'All provinces except provinces that specify in shipping area',
  shipping_area_type: 'Shipping area type',
  country_name_list: 'Countries name list',
  province_name_list: 'Provinces name list',
  select_province: 'Select province',
  no_province_result: 'No provinces found',
  display_not_specify: 'Not specify',
  change_shipping_type_confirm_description: 'Confirm to change shipping area type from <b>[change_from]</b> to <b>[change_to]</b>',
  order_pointspot_receive_point: 'Points received from Pointspot',
  sorting_option_setting: 'Sorting',
  sorting_option_product_category: 'Product Category',
  sorting_option_product: 'Product',
  sorting_option_sort_by: 'Sort by',
  edit_product_sorting: 'Edit products sorting',
  edit_category_sorting: 'Edit product categories sorting',
  affect_to_label: 'Affect to',
  all_products_list: 'All products list',
  new_products_list: 'New products list',
  all_category_list: 'All categories list',
  new_category_list: 'New categories list',
  all_categories_sort_label: 'Sort by',
  sort_category: 'Sort Category',
  publish_sort_category_action_suggest: 'Apply these changes to your website',
  publish_sort_category_btn: 'Publish',
  product_advance_search_status: 'Status',
  product_advance_search_status_show: 'Show',
  product_advance_search_status_hide: 'Hide',
  not_defined: 'None',
  products_card_move_to_first: 'Move to first',
  products_card_move_to_last: 'Move to last',
  products_card_move_to_specific_target: 'Move to specific target',
  products_sorting_waiting_to_publish: 'Apply these changes to your website',
  products_in_this_category_label: 'Only this category',
  products_under_category_label: 'Include sub categories',
  sort_product_btn: 'Sort Product',
  no_category_childs_label: 'Category not found under this category',
  products_card_move_after: 'Move after',
  error_product_order_range: 'Please specific order from 1 - {max}',
  product_sorting_title: 'Product Sorting',
  product_sorting_newest: 'New product to old product',
  product_sorting_oldest: 'Old product to new product',
  product_sorting_name_asc: 'Product name A-Z',
  product_sorting_name_desc: 'Product name Z-A',
  product_sorting_price_asc: 'Product price low to high',
  product_sorting_price_desc: 'Product price high to low',
  category_sorting_newest: 'New category to old category',
  category_sorting_oldest: 'Old category to new category',
  category_sorting_name_asc: 'Category name A-Z',
  category_sorting_name_desc: 'Category name Z-A',
  product_filter_max: 'Not Exceeded',
  product_filter_min: 'From',
  product_filter_equal: 'Equals',
  upload_image_multiple_select: 'Multiple images at once.',
  upload_image_multiple_recommend_image_size: 'Recommended image size is {image_size}.',
  upload_image_multiple_recommend_file_size: 'File size not exceed {file_size}.',
  upload_image_multiple_max_number_of_files: 'Maximum {number} images.',
  payment_method_type_transfer: 'Transfer',
  payment_method_type_cash: 'Cash on Delivery',
  payment_method_type_other: 'Others',
  payment_setting_type: 'Type',
  payment_setting_channel: 'Channel',
  payment_setting_methods: 'Methods',
  payment_setting_channel_placeholder: 'Bank Name / Account No',
  payment_setting_description: 'Description',
  payment_setting_description_placeholder: 'Account Name / More Details',
  payment_setting_show_payment_evidence: 'Show Payment Evidence Button',
  payment_setting_show_payment_evidence_yes: 'Yes',
  payment_setting_show_payment_evidence_no: 'No',
  cannot_remove_last_image: 'Can\'t delete last image',
  shipping_pricing: 'Pricing',
  shipping_service: 'Shipping services',
  product_variant_image_upload_not_save: 'Please save your product before upload images.',
  order_update_date: 'Order Date',
  order_status: 'Status',
  order_type_merchant: 'Merchant',
  order_status_new: 'New',
  order_status_confirm: 'Pending',
  order_status_paid: 'Paid',
  order_status_delivering: 'Delivering',
  order_status_delivered: 'Delivered',
  order_advance_search_between: 'Between',
  btn_add_order: 'Add order',
  order_status_detail: 'Order Status',
  order_tracking_number: 'Tracking Number',
  order_delivered_date: 'Delivered on',
  order_check_tracking: 'Check',
  new_order_header: 'Create Order',
  edit_order_header: 'Edit Order',
  order_url: 'Order URL',
  order_district: 'District',
  order_sub_district: 'Sub District',
  btn_new_order_save: 'Save',
  add_new_product: 'Add new products',
  add_product_search: 'Product name, Product SKU',
  add_product_successful: 'Add product successful',
  add_product_failed: 'This product is already added',
  add_new_order_alert: 'Please add at least 1 product',
  order_address_line2: 'Address 2',
  btn_copy_order_url: 'Copy order URL',
  alert_copy_success: 'Copied success',
  validatefail_product_sales_value: 'Incorrect default value',
  product_sales_label: 'Products Sold',
  product_sold_label: 'Sold',
  product_sold_display: 'Display value',
  not_add_product_label: 'No product added yet',
  product_sold_default_label: 'Default',
  menu_order_list: 'Orders',
  tooltip_menu_order_list: 'Order List',
  add_new_product_search_alert_label: 'Please enter the keyword',
  label_order_country_select: 'Select Country',
  label_order_province_select: 'Select Province',
  label_order_district_select: 'Select District',
  label_order_sub_district_select: 'Select Sub District',
  label_btn_delete_product_mobile: 'Delete Product',
  label_total_product_product_mobile: 'Total',
  label_btn_create_in_chat_order: 'Create In-Chat Order',
  label_in_chat_order: 'In-Chat Order',
  label_normal: 'Normal',
  label_btn_copy_order_in_chat_url: 'Copy Order URL In-Chat',
  label_address_toggle: 'Address Information',
  label_product_over_stock_alert: 'Product quantity is not enough',
  order_total_table: 'Grand Total',
  order_total_table_header: 'Total',
  error_product_order_variant_empty: 'Please specific product variant',
  order_address_line1: 'Address',
  label_product_over_stock_alert_not_correct: 'Please specific product quantity',
  pricing_model_per_unit: 'Per unit',
  pricing_model_tier: 'Tiered',
  pricing_model_unit: 'Unit pricing',
  pricing_model_volume: 'Volume pricing',
  label_pricing_model: 'Pricing Model',
  pricing_volume_range: 'Quantity',
  pricing_tier_range: 'Quantity',
  above: 'Above',
  edit_order_status: 'Edit Order Status',
  open_rcrm_order_detail: 'View Detail',
  product_step_price_add_range: 'Add range',
  price_volume_variants_affected_warning: 'Product variants will be affected by volume price settings automatically',
  price_volume_range_error_message: 'Invalid quantity range',
  price_volume_prices_error_message: 'Invalid price',
  order_details: 'Order',
  not_specified: 'Not specified',
  product_list_product_variants: 'Have product variants',
  variant_setting_title_change_page_modal: 'Are you changing page without save ?',
  variant_setting_title_change_tab_modal: 'Are you changing menu tab without save ?',
  variant_setting_confirm_change_page_modal: 'Yes, Don\'t save',
  save_basic_setting_button: 'Save Basic Settings',
  save_variant_setting_button: 'Save Variants',
  add_new_order_quantity_alert: 'Please verify Qty and total prices',
  product_under_category_over_limit: 'Please use standard product sorting.',
  product_image_modal_error_occured: 'Incorrect file type, please try again.'
}



// WEBPACK FOOTER //
// ./src/store/i18n/en.js